import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Register } from '../../_models/register';
import { Notification } from '../../notification';
import { Caller } from '../../_models/caller';
import { ApiIntegration } from '../../_services/api.integration';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';


@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.css']
})

export class NotificationListComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();

  statusText: string = "";
  notificationTypes: any;
  selectDeleteNotify: any;
  notificationForDelete: any;
  notificationToModify: any;
  tabClicked: string = "all";
  errorMessage: string;
  checkedList: any;
  masterSelected: boolean = false;
  previousStatus = '';
  notifyStatus: any = 'ALL';
  userDrop2: any = 'ALL';
  totalRecords: number;
  constructor(private alertService: AlertService, private excelService: ExcelServiceService, private http: HttpClient, private router: Router, private api: ApiIntegration, public notification: Notification, public register: Register, public caller: Caller, public g: Globals) {
    //  this.getNotifyByStatus("ALL");
    this.g.page = "Notifications";
    this.populateTabData('all', "ALL");
  }
  populateTabData(triggered, notifyStatus) {
    this.tabClicked = triggered;
    this.notifyStatus = notifyStatus;
    if (!this.previousStatus) {
      this.getNotifyByStatus(notifyStatus);
    } else {
      this.rerender();
    }
  }


  populate(orderChange) {
    this.api.getStatus("1", orderChange).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.notificationTypes = data.notificationsList;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  getNotifyByStatus(status) {
    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Type'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.notifyStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.notifyStatus;
        }
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/notifications/1/' + this.notifyStatus;
        let query: any = {
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.notificationTypes = resp.notificationsList;
            this.totalRecords = resp.noOfRecords;
            this.g.loaderDisplay = "";
            this.notificationTypes.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };

  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.notificationTypes, 'sample');
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {

    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  checkUncheckAll() {
    for (var i = 0; i < this.notificationTypes.length; i++) {
      this.notificationTypes[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  selectShip(sl) {
    if (!sl.isSelected) { this.masterSelected = false }
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.notificationTypes.length; i++) {
      if (this.notificationTypes[i].isSelected) {
        this.checkedList.push(this.notificationTypes[i]['notificationId']);
      }
    }

  }

  editNotification(notificationTypes) {
    this.checkedList = [];
    let i = 0;
    let ohid;
    for (let notify of notificationTypes) {
      if (notify.isSelected) {
        i = i + 1;
        ohid = notify.notificationId;
      }
    };
    if (i === 1) {
      this.router.navigate(['/admin/editNotify/' + ohid]);
    } else {
      this.errorMessage = "Can not Edit multiple notifications at once. Please select one at a time";
    }
  }


  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  deleteNotificatios(notificationTypes) {
    this.checkedList = [];
    for (let n of notificationTypes) {
      if (n.isSelected) {
        this.selectNotificationTypeForDelete(n);
        this.deleteNotify();
      }
    }
  }

  changeStatus(n) {
    this.g.loaderDisplay = "display";
    if (n.status == "ACTIVE") {
      n.status = "IN_ACTIVE";
      this.rerender();
    } else {
      n.status = "ACTIVE";
      this.rerender();
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/changeNotificationStatus', {
      "organizationId": 1,
      "notificationId": n.notificationId,
      "status": n.status
    }, { headers: header1 }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.alertService.success('Notification', 'Status Updated Successfully');

      } else {
        this.alertService.error('Error', data['message']);
      }
    },
      (err: HttpErrorResponse) => {

        this.g.loaderDisplay = "";
      });

    if (this.tabClicked != 'all') {
      let index = this.notificationTypes.indexOf(n);
      this.notificationTypes.splice(index, 1);
    }
  }

  deleteNotify() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/archivedNotification', {
      "notificationId": this.notificationForDelete.notificationId,
      "organizationId": 1,
      "status": "ARCHIVED"
    },
      { headers: header1 }).subscribe(data => {
        this.checkedList = [];
        this.masterSelected = false;
        this.checkedList = [];
        this.g.loaderDisplay = "";
        if (data['code'] == '200') {
          this.alertService.success('Notification', 'Deleted Successfully');

          /*let index = this.notificationTypes.indexOf(this.notificationForDelete);
          this.notificationTypes.splice(index,1);*/
          this.getNotifyByStatus("ACTIVE");

        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        });

  }

  selectNotificationTypeForDelete(n) {
    this.notificationForDelete = n;
  }
}
